import { render, staticRenderFns } from "./Impostazioni.vue?vue&type=template&id=e14e0bd4&scoped=true&"
import script from "./Impostazioni.vue?vue&type=script&lang=js&"
export * from "./Impostazioni.vue?vue&type=script&lang=js&"
import style0 from "./Impostazioni.vue?vue&type=style&index=0&id=e14e0bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14e0bd4",
  null
  
)

export default component.exports